import { render, staticRenderFns } from "./AddExistingUserGroup.vue?vue&type=template&id=72c456be&scoped=true"
import script from "./AddExistingUserGroup.vue?vue&type=script&lang=js"
export * from "./AddExistingUserGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c456be",
  null
  
)

export default component.exports